import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import EmailTemplate from 'features/EmailCampaign/EditEmail/EmailTemplate'

const EditEmail = () => (
  <div>
    <CustomHeader title="Edit email" width={1120} />
    <EmailTemplate />
  </div>
)

export default EditEmail
